//don't add any newlines between the tick marks, otw you'll get a blank item in the bucket of texts
const sentenceText_fr = `Ma montre est tombée à l'eau.
Respirez c'est difficile.
Je peux voir les anneaux de Saturne.
La physique et la chimie, c'est dur.
Mon compte en banque est à découvert.
Nous avons un souper spaghetti.
Les éléphants ont peur des souris.
C'est l'endroit que j'aime le plus visiter.
Attention les couteaux volent bas.
S'il vous plaît donnez votre date de naissance.
Nous risquons de nous blesser.
Il est comme tout le monde.
Le monde est une étape.
Est-ce que tu me parles?
Oui, tu es très intelligent.
Que la force soit avec toi.
As-tu eu du plaisir?
L'espace est une de nos priorités.
Tu es un très bon exemple.
Ne perdez pas votre temps.
N'en buvez pas trop.
La musique est mieux que ce que l'on entend.
Viens voir notre nouvelle voiture.
Je m'en vais à un cours de musique.
Bientôt nous reviendrons de la ville.
Je porte un veston et une cravate.
Il y aura un peu de brouillard ce soir.
Je suis allergique aux abeilles et aux arachides.
Il est toujours dans notre équipe.
Ma friandise préférée est le chocolat.
Le roi vous envoie à la tour.
Nous sommes les sujets et devons obéir.
Ma mère lui a fait un chandail à col roulé.
Nous sommes allés à l'épicerie.
Le rendez-vous est pour aujourd'hui.
Ce que vous voyez est ce que vous aurez.
La boutique fermera à 10 heures.
C'est très malheureux.
C'est une très bonne idée.
Ton numéro de téléphone a changé.
Merci pour ton aide.
La bibliothèque est fermée aujourd'hui.
Marie a un petit mouton.
Cette montre est trop dispendieuse.
Le service postal est très lent.
L'automne est ma saison préférée.
Le renard est un animal très intelligent.
Les enfants sont très énervés.
L'espace de stationnement est rempli de camions.
Mon vélo a une crevaison.
Ne marche pas trop vite.
Un canard "crie" pour demander de la nourriture.
Le soleil se lève à l'est.
C'est très venteux aujourd'hui.
Ne t'en fais pas trop pour ça.
Il portait un chandail.
Je te rencontrerai à midi.
Je veux te tenir la main.
Les enfants jouent à l'extérieur.
Aimes-tu magasiner le dimanche?
J'ai renversé du café sur la moquette.
La forêt est très dense par endroit.
L'âne et le boeuf sont les animaux de la crèche.
Ne pas boire l'eau.
Mon auto tombe toujours en panne en hiver.
Aimes-tu aller faire du camping?
Les protestataires bloquent toute la circulation.
Le discours d'ouverture était ennuyant.
Travaille fort pour atteindre le sommet.
Une bonne blague permet de bien rire.
Le syndicat va déclarer la grève.
Ne jamais mélanger la religion et la politique.
Les billets sont très chers.
Une image vaut mille mots.
Cet appareil prend de belles photos.
Ç'a l'air d'une cabane.
Le chien gruge son os.
Je ne peux juste pas m'imaginer.
Veuillez suivre les indications.
Un aéroport est un endroit très achalandé.
L'autobus était très bondé.
Ça devrait être ensoleillé demain.
Un médecin pourra t'aider.
Tu devrais voir un dentiste.
Vous devez prendre rendez-vous.
Les joueurs doivent connaître toutes les règles.
Aimerais-tu venir chez moi?
Février a une journée supplémentaire.
Ne t'en fais pas trop pour ça.
Cette bibliothèque a beaucoup de livres.
C'est difficile de se concentrer.
J'écoute la cassette tous les jours.
Il crie très fort.
La fiche ne correspond pas à la prise.
Nous soupons au restaurant les fins de semaine.
Le niveau d'eau est évalué à chaque jour.
Il a regardé avec étonnement.
Il y avait une grosse éraflure sur le dessus de la table.
Les vendeurs doivent atteindre leurs objectifs.
Porter secours à cet enfant était un geste héroïque.
Le granit est la roche la plus dure.
Nous avons assez de témoins.
Les dauphins bondissent haut hors de l'eau.
Le système de ventilation est défectueux.
Les dinosaures se sont éteints il y a fort longtemps.
Les hautes vagues vont nous emporter.
La trésorière doit balancer ses livres.
Ils ont regardé le film en entier.`;

export default sentenceText_fr;
